import pp1 from "../images/profile-pic-1.jpeg";
import pp2 from "../images/profile-pic-2.jpeg";
import pp3 from "../images/profile-pic-3.jpeg";
import pp4 from "../images/profile-pic-4.jpeg";
import pp5 from "../images/profile-pic-5.jpeg";
import pp6 from "../images/profile-pic-6.jpeg";

import ni1 from "../images/name-img/squid-game.png";

import pi1 from "../images/previews/squid-game.png";

export const getProfilePicCodeDirect = (id) => {
    return id === 1 ?
                pp1 : id === 2 ?
                    pp2 : id === 3 ?
                        pp3 : id === 4 ?
                            pp4 : id === 5 ?
                                pp5 : pp6
}

export const getProfilePicCode = (from) => {
    return from.profile_pic_id === 1 ?
                pp1 : from.profile_pic_id === 2 ?
                    pp2 : from.profile_pic_id === 3 ?
                        pp3 : from.profile_pic_id === 4 ?
                            pp4 : from.profile_pic_id === 5 ?
                                pp5 : pp6
}

export const imgNameObj = {
    "7b8ad234": ni1
}

export const previewPosterImage = {
    "7b8ad234": pi1
}